import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { BUSINESS } from "@/lib/site";
import { Reveal } from "@/components/Reveal";
import { AccentTitle } from "@/components/AccentTitle";

export const CtaBand = ({ serif = false }) => (
  <section data-testid="cta-band" aria-labelledby="cta-heading" className="section bg-navy text-white">
    <div className="container-site">
      <Reveal className="max-w-[760px]">
        <h2 id="cta-heading" data-testid="cta-heading" className={serif ? "font-serif font-bold text-white" : "text-white"}>
          {serif ? <AccentTitle title="Ready To Start Your Project?" accent="Project" /> : "Ready To Start Your Project?"}
        </h2>
        <p className="mt-4 text-base text-white/80 md:text-lg">
          Speak to {BUSINESS.founderFirstName} directly. Free site visit, fixed written quote, no deposit.
        </p>
        <div className="mt-8 flex flex-col gap-6 sm:flex-row sm:items-center sm:gap-10">
          <a
            href={BUSINESS.phoneHref}
            data-testid="cta-phone-link"
            className="text-4xl font-bold tracking-[-0.015em] text-brand transition-colors duration-200 hover:text-white md:text-5xl"
          >
            {BUSINESS.phone}
          </a>
          <Link to="/contact" data-testid="cta-quote-button" className="btn btn-brand w-full sm:w-auto">
            Get a Free Quote
          </Link>
        </div>
        <a
          href={BUSINESS.whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-whatsapp-link"
          className="mt-6 inline-flex items-center gap-2 text-[15px] font-medium text-white/80 transition-colors duration-200 hover:text-white"
        >
          <MessageCircle size={18} aria-hidden="true" />
          Or message us on WhatsApp
        </a>
      </Reveal>
    </div>
  </section>
);
